import { queryKeyFn, invalidateUserQuery } from '@sit/client-shared';
import { queryClient } from '@web/query-client';

export function* updateAccessToken() {
  invalidateUserQuery(queryClient);
  yield queryClient.invalidateQueries(
    queryKeyFn({
      path: '/companies',
      operationId: 'getApiCompany',
      variables: {},
    }),
  );
}
